export default {
  create: {
    method: 'post',
    url: '/quote/quote-request'
  },
  createAndRequestPrice: {
    method: 'post',
    url: '/quote/quote-request/request-price'
  },
  get: {
    method: 'post',
    url: '/quote/quote-request/list'
  },
  getDetail: {
    method: 'get',
    url: '/quote/quote-request/ID'
  },
  edit: {
    method: 'put',
    url: '/quote/quote-request/ID'
  },
  delete: {
    method: 'delete',
    url: '/quote/quote-request'
  },
  archive: {
    method: 'delete',
    url: '/quote/quote-request/archive'
  },
  restore: {
    method: 'put',
    url: '/quote/quote-request/restore'
  },
  viewTimeComplete: {
    method: 'get',
    url: '/quote/quote-request/view-time-complete/IDBUSINESSOPPORTUNITY'
  },
  find: {
    method: 'get',
    url: '/quote/quote-request/find?key=KEY'
  },
  requestPrice: {
    method: 'post',
    url: '/quote/quote-request/request-price/ID'
  },
  tollStation: {
    method: 'post',
    url: '/quote/quote-request/toll-station'
  },
  routingConnection: {
    method: 'post',
    url: '/quote/quote-request/routing-connection'
  }
}
